import Axios from "axios";
import { config } from '../../config/Constants';

export const searchReport = async ({ 
  reportId, searchKey, searchValue, page = 1, pageSize = 50, 
}) => {
  try {
    const response = await Axios.get(config.url.SEARCH_REPORT, {
      params: { 
        reportId, 
        searchKey, 
        searchValue, 
        page, 
        pageSize 
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
    return { error: true };
  }
};
